<template>
  <div v-show="show" class="message-box">
    <div class="message" ref="vmessage">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VMessage',
  mounted() {
    this.StartTime();
  },
  data() {
    return {
      message: '',
      show: false,
      timer: null
    };
  },
  methods: {
    StartTime() {
      this.show = true;
      if (this.timer) {
        window.clearTimeOut(this.timer);
      } else {
        this.timer = setTimeout(() => {
          // this.ref.vmessages.className += ' message-out'
          this.show = false;
        }, 3000);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.message-box{
  position: fixed;
  min-height: 300px;
  width: 300px;
  left: 50%;
  box-sizing: border-box;
  margin-left: -150px;
  text-align: center;
  top: 0px;
  cursor: pointer;
  transform: all ease-in-out 3s;
  height: auto;
  z-index: 999;

  .message{
    position: relative;
    // margin-top: 30px;
    padding: 10px;
    font-size: 14px;
    background-color: #fff;
    transform: all ease-in-out 3s;
    height: 39px;
  }

  .success{
    background-color: #DEFCD5;
    color: #52A954;
  }

  .warn{
    background-color: #F1D7D7;
    color: #A95252;
  }

  .message-out{
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Message.vue?902d7f08